import React, { useEffect, useState, useRef } from "react";
import HTMLFlipBook from "react-pageflip";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";

// Configurer pdf.js
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const LazyPage = React.forwardRef(({ pageNumber, pdfFile, visible }, ref) => {
  return (
    <div className="demoPage" ref={ref}>
      {visible ? (
        <Document file={pdfFile}>
          <Page
            pageNumber={pageNumber}
            renderAnnotationLayer={false}
            renderTextLayer={false}
            width={350}
          />
        </Document>
      ) : (
        <div style={{ height: "500px", width: "350px", backgroundColor: "#eee" }}>
          Loading...
        </div>
      )}
    </div>
  );
});

function FlipBook() {
  const [numPages, setNumPages] = useState(null);
  const [pdfFile, setPdfFile] = useState(null);
  const [currentPage, setCurrentPage] = useState(0); // Track current page
  const bookRef = useRef(); // Référence pour le FlipBook

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file && file.type === "application/pdf") {
      const fileURL = URL.createObjectURL(file);
      setPdfFile(fileURL);
    } else {
      alert("Veuillez sélectionner un fichier PDF valide.");
    }
  };

  const handleFlip = (e) => {
    setCurrentPage(e.data);
  };

  return (
    <div className="bg-gray-900 h-screen flex flex-col justify-start items-start overflow-hidden">
      <div className="flex flex-col items-start p-4">
        <div className="text-xl font-bold text-white mb-2">From PDF to Flipbook</div>
        <input
          type="file"
          accept="application/pdf"
          onChange={handleFileUpload}
          className="mb-4 px-4 py-2 border border-gray-300 rounded bg-white"
        />
      </div>

      {pdfFile && numPages && (
        <div className="flex flex-grow justify-center items-center w-full">
          <HTMLFlipBook
            width={350}
            height={500}
            showCover={true}
            ref={bookRef}
            onFlip={handleFlip}
          >
            {[...Array(numPages).keys()].map((n) => (
              <LazyPage
                key={n}
                pageNumber={n + 1}
                pdfFile={pdfFile}
                visible={n >= currentPage - 1 && n <= currentPage + 1} // Load only adjacent pages
              />
            ))}
          </HTMLFlipBook>
        </div>
      )}

      {pdfFile && !numPages && (
        <Document file={pdfFile} onLoadSuccess={onDocumentLoadSuccess} />
      )}
    </div>
  );
}

export default FlipBook;
